import { CommandCode, } from "../../../utils/network/generated/protoTypes";
export var requestContractInfo = function (state$, deps) { return function () {
    var state = state$.value;
    return deps.netSend({
        id: CommandCode.ContractInfo,
        props: {
            farmId: state.playerBase.base.baseId,
            playerId: state.playerInfo.playerId,
        },
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/requestContractInfo.ts
// module id = 1992
// module chunks = 3